import Instructions from './Instructions'
import Gallery from './Gallery'
import Panorama from './Panorama'

export default [
  {
    path: 'instructions',
    component: Instructions,
  },
  {
    path: 'gallery',
    component: Gallery,
  },
  {
    path: 'panorama',
    component: Panorama,
  },
]
